module.exports = __webpack_public_path__ + "static/media/energyCIntensiveCream.307cd2d4.png";